import newsfeedNotificationsUrl from './newsfeed-notifications.html';
export default {
  controllerAs: 'ctrl',
  bindings: {
    notifications: '<',
  },
  templateUrl: newsfeedNotificationsUrl,
  controller: class NewsfeedNotificationsCtrl {
    constructor(NewsfeedCollection, $scope) {
      'ngInject';

      $scope.$watch('ctrl.isScrolledDown', async (isScrolledDown) => {
        if (isScrolledDown) {
          this.loading = true;
          try {
            await NewsfeedCollection.loadMoreNotifications();
          } finally {
            this.loading = false;
          }
        }
      });
    }
  },
};
